import React from 'react'

export const Header = () => {
  return (
    <h2>
      Money Mate
    </h2>
  )
}
